import api from './api';

// Serviço para gerenciar extensões
export const extensaoService = {
  // Listar extensões com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/extensoes', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar extensões');
    }
  },

  // Buscar extensão por ID
  async getById(id) {
    try {
      const response = await api.get(`/extensoes/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar extensão');
    }
  },

  // Criar extensão
  async create(extensaoData) {
    try {
      const response = await api.post('/extensoes', extensaoData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao criar extensão');
    }
  },

  // Atualizar extensão
  async update(id, extensaoData) {
    try {
      const response = await api.put(`/extensoes/${id}`, extensaoData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar extensão');
    }
  },

  // Deletar extensão
  async delete(id) {
    try {
      const response = await api.delete(`/extensoes/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir extensão');
    }
  },

  // Buscar estatísticas de extensões
  async getStats() {
    try {
      const response = await api.get('/extensoes/stats');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar estatísticas');
    }
  }
};

// Funções de compatibilidade com código existente
export const fetchExtensoes = async (params = {}) => {
  // Se não especificar limit, buscar todas as extensões
  if (!params.limit) {
    params.limit = 1000;
  }
  const result = await extensaoService.list(params);
  return result.data;
};

export const fetchExtensaoById = async (id) => {
  const result = await extensaoService.getById(id);
  return result.data;
};

export const createExtensao = async (data) => {
  return await extensaoService.create(data);
};

export const updateExtensao = async (id, data) => {
  return await extensaoService.update(id, data);
};

export const deleteExtensao = async (id) => {
  return await extensaoService.delete(id);
};

export default extensaoService;
